"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermFunctionStrLangdir = void 0;
const bus_function_factory_1 = require("@comunica/bus-function-factory");
const utils_expression_evaluator_1 = require("@comunica/utils-expression-evaluator");
const expressions_1 = require("@comunica/utils-expression-evaluator/lib/expressions");
/**
 * https://www.w3.org/TR/sparql11-query/#func-strlang
 */
class TermFunctionStrLangdir extends bus_function_factory_1.TermFunctionBase {
    constructor() {
        super({
            arity: 3,
            operator: utils_expression_evaluator_1.SparqlOperator.STRLANGDIR,
            overloads: (0, utils_expression_evaluator_1.declare)(utils_expression_evaluator_1.SparqlOperator.STRLANGDIR)
                .onTernaryTyped([utils_expression_evaluator_1.TypeURL.XSD_STRING, utils_expression_evaluator_1.TypeURL.XSD_STRING, utils_expression_evaluator_1.TypeURL.XSD_STRING], () => (val, language, direction) => {
                if (!language) {
                    throw new utils_expression_evaluator_1.ExpressionError(`Unable to create directional language string for empty languages`);
                }
                if (direction !== 'ltr' && direction !== 'rtl') {
                    throw new utils_expression_evaluator_1.ExpressionError(`Unable to create directional language string for direction "${direction}"`);
                }
                return new expressions_1.DirLangStringLiteral(val, language.toLowerCase(), direction);
            })
                .collect(),
        });
    }
}
exports.TermFunctionStrLangdir = TermFunctionStrLangdir;
//# sourceMappingURL=TermFunctionStrLangdir.js.map